import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../providers/auth.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { AppSettings } from '../../app.settings';
import { faDotCircle, faLock, faShieldCheck, faUsers }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
styleUrls:  ['./login.component.css']
})
export class LoginComponent extends SmsAbstractAppPage implements OnInit {

	model: any = {username: '', password: ''};
  faDotCircle = faDotCircle;
  faLock = faLock;
  faShieldCheck = faShieldCheck;
  faUsers = faUsers;

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {
  	super();
  }

  ngOnInit() {
  }

  login(){
  	this.authService.login(this.model.username, this.model.password)
            .then(result => {
                if (result == true) {
                    // login successful
                    this.router.navigate(['home']);
                } else {
                    // login failed
                    this.handleError('Username or password is incorrect');
                }
            }).catch(error => {
              this.handleError(error);
            });
  }

  handleCreateAccount(){
    this.router.navigate(['create-user']);
  }

  handleLostPassword(){
    this.router.navigate(['lost-password']);
  }

}
